import { ParamethorResponse, PostApiParamethorBody } from '@spo/types';
import { apiBff } from '.';

export const getParameters = async ({
  parameterName,
  uid,
}: PostApiParamethorBody): Promise<ParamethorResponse> =>
  apiBff.callBFF('POST', 'paramethor', { parameterName, uid });
